import React, { useEffect, useRef, useState } from 'react';
import { Skeleton, useMediaQueryContext } from '@fourthwall/components';
import * as S from './styled';
export const IFramePreview = ({ url, align = 'center', fluid, onClick }) => {
    const media = useMediaQueryContext();
    const containerRef = useRef(null);
    const iFrameRef = useRef(null);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [containerHeight, setContainerHeight] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);
    const [previewHeight, setPreviewHeight] = useState(0);
    const [previewWidth, setPreviewWidth] = useState(0);
    const [iFrameWidth, setIFrameWidth] = useState(0);
    const [iFrameHeight, setIFrameHeight] = useState(0);
    const [fluidContainerHeight, setFluidContainerHeight] = useState(0);
    useEffect(() => {
        if (!containerRef.current || !iFrameRef.current)
            return;
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                setContainerHeight(entry.target.offsetHeight);
                setContainerWidth(entry.target.offsetWidth);
                if (iFrameRef.current) {
                    const iframeWidth = iFrameRef.current.getBoundingClientRect().width;
                    const iframeHeight = iFrameRef.current.getBoundingClientRect().height;
                    setIFrameWidth(iframeWidth);
                    setIFrameHeight(iframeHeight);
                    if (iframeWidth < containerWidth) {
                        const aspectRatio = iframeWidth / iframeHeight;
                        const widthToIncrease = containerWidth - iframeWidth;
                        const heightToIncrease = widthToIncrease / aspectRatio;
                        setFluidContainerHeight(heightToIncrease);
                    }
                }
            });
        });
        resizeObserver.observe(containerRef.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, []);
    useEffect(() => {
        if (iFrameRef.current && iframeLoaded) {
            const iframeWidth = iFrameRef.current.getBoundingClientRect().width;
            const iframeHeight = iFrameRef.current.getBoundingClientRect().height;
            if (iframeWidth < containerWidth) {
                const aspectRatio = iframeWidth / iframeHeight;
                const widthToIncrease = containerWidth - iframeWidth;
                const heightToIncrease = widthToIncrease / aspectRatio;
                setFluidContainerHeight(heightToIncrease);
            }
            setIFrameWidth(iframeWidth);
            setIFrameHeight(iframeHeight);
        }
    }, [iframeLoaded]);
    return (React.createElement(S.Container, { align: align },
        React.createElement(S.IframeContainer, { ref: containerRef, style: iframeLoaded ? { height: iFrameHeight + (fluid ? fluidContainerHeight : 0) } : {} },
            React.createElement(S.Iframe, { src: url, width: media.tablet ? window.innerWidth / 1.5 : window.innerWidth, height: media.tablet ? window.innerHeight / 1.5 : window.innerHeight, loaded: iframeLoaded, ref: iFrameRef, style: {
                    '--containerHeight': `${containerHeight}`,
                    '--containerWidth': `${containerWidth}`,
                    '--previewHeight': `${previewHeight}`,
                    '--previewWidth': `${previewWidth}`,
                }, onLoad: (e) => {
                    if (containerRef.current) {
                        const iframe = e.target;
                        setContainerHeight(containerRef.current.offsetHeight);
                        setContainerWidth(containerRef.current.offsetWidth);
                        setPreviewHeight(iframe.contentDocument?.querySelector('.fw-section')?.offsetHeight);
                        setPreviewWidth(iframe.contentDocument?.querySelector('.fw-section')?.offsetWidth);
                        setIframeLoaded(true);
                    }
                } }),
            iframeLoaded && (React.createElement(S.Overlay, { style: {
                    height: iFrameHeight + 12 + (fluid ? fluidContainerHeight : 0),
                    width: fluid ? undefined : iFrameWidth + 12,
                }, onClick: onClick })),
            iframeLoaded ? null : (React.createElement(S.SkeletonWrapper, null,
                React.createElement(Skeleton.Shape, { width: "100%", height: "100%" }))))));
};
